import { createBookingsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const BookingsService = createBookingsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
